import config from 'config';
import request from 'helpers/superagent';

const queryAsync = (url) => (query, variable) => {
  const {access_token} = localStorage;
  return request.post(url + '/graphql')
    .query({
      access_token,
      raw: true,
    })
    .send({
      query: query,
      variables: variable,
    })
    .endAsync()
    .get('body');
}

const updateAsync = (url) => (query, variable) => {
  const {access_token} = localStorage;
  return request.post(url + '/graphql')
    .query({
      access_token,
      raw: true,
    })
    .send({
      query: query,
      variables: variable
    })
    .endAsync()
    .get('body');
}

export const eadminQueryAsync = queryAsync(config.eadmin.baseUrl);
export const eadminUpdateAsync = updateAsync(config.eadmin.baseUrl);

export const edataQueryAsync = queryAsync(config.edata.baseUrl);
export const edataUpdateAsync = updateAsync(config.edata.baseUrl);

export const subjectQueryAsync = queryAsync(config.subject.baseUrl);
export const subjectUpdateAsync = updateAsync(config.subject.baseUrl);

export const minerQueryAsync = queryAsync(config.miner.baseUrl);
export const minerUpdateAsync = updateAsync(config.miner.baseUrl);

export const mediaQueryAsync = queryAsync(config.media.baseUrl);
export const mediaUpdateAsync = updateAsync(config.media.baseUrl);

export const elogQueryAsync = queryAsync(config.elog.baseUrl);



/** WEBPACK FOOTER **
 ** ./src/app/helpers/graphql.js
 **/